<template>
	<div class="download">
		<div class="">
			<div class="title">DownLoad</div>
			<div class="down-list">
				<ul>
					<li class="link-list" v-for="vo in list">
						<a :href="vo.url" download v-text="vo.filename">The InflamNat_All_Act data(version
							20210402)</a>
						({{vo.name}})
					</li>
					<!--li class="link-list">
						<a href="./3_InflamNat_Target_20210402.xlsx" download>The InflamNat_Target data(version
							20210402)</a>
						(Molecular Targets of InflamNat Compounds)
					</li>
					<li class="link-list">
						<a href="./4_All_target_info.xlsx" download>The All target info data(version 20210402)</a>
						(Basic information of the targets)
					</li-->
				</ul>
			</div>

		</div>
	</div>
</template>
<script>
	export default {
		name: "home",
		data() {
			return {
				list: [],
			}
		},


		methods: {

			getData() {
				let _this = this
				let form = {}
				this.$http({
					url: "/api/rdkit/querydownload",
					params: form,
					method: "get",
				}).then((res) => {
					_this.list = res.data.data
				});
			}
		},
		mounted() {

			this.getData()
		}

	}
</script>
<style scoped>
	.download {
		padding: 0 180px;
		margin: 0 auto;
		min-height: 512px;
	}

	.title {
		font-size: 30px;
		font-weight: 600;
		height: 50px;
		color: #409EFF;
		border-bottom: 2px solid rgb(245, 166, 20);
		text-align: center;
	}

	.down-list {
		margin: 20px 0;
	}

	.down-list ul li {
		line-height: 30px;
		font-size: 18px;
	}

	.down-list ul li a {
		color: #409EFF;
	}
</style>sty
